<template>
  <el-card shadow="never" class="bg-music-container">
    <div class="header">
      <div class="header-left">
        <div class="cover" @click="playAudio">
          <el-image :class="{ 'rotating': isPlaying }" :src="require('@/assets/images/music.png')"
            fit="contain"></el-image>
          <div v-if="designerStore.videoBgmData.bgmUrl" class="cover-shade">
            <svgIcon :iconClass="isPlaying ? 'pusewhite' : 'play'" width="16px" height="16px" />
          </div>
        </div>
        <div>
          <div class="title">{{ designerStore.videoBgmData.bgmUrlName || title }}</div>
          <div class="subtitle">{{ subtitle }}</div>
        </div>
      </div>
      <div class="header-right" @click="emits('clickArrowRightFn')">
        <el-icon>
          <ArrowRight />
        </el-icon>
      </div>
    </div>
    <div v-if="designerStore.videoBgmData.bgmUrl" class="controls">
      <div class="control">
        <label>音量</label>
        <el-slider v-model="designerStore.videoBgmData.bgmVolume" size="small" :step="0.1" :min="0" :max="1" />
      </div>
    </div>

    <div v-if="designerStore.videoBgmData.bgmUrl" style="text-align: right;">
      <el-button type="danger" :icon="Close" circle size="small" @click="designerStore.initVideoBgmDataFn()" />
    </div>
    <slot></slot>
  </el-card>
</template>

<script setup>
import { ref, defineProps, watch, defineEmits } from 'vue'
import { Close, } from '@element-plus/icons-vue'
import { useAudioPlayer } from '@/hooks/useAudioPlayer.ts';
import { useDesignerStore } from '@/pinia/index';
const emits = defineEmits([
  'clickArrowRightFn'
]);
const designerStore = useDesignerStore();

const props = defineProps({
  title: {
    type: String,
    default: '背景音乐'
  },
  subtitle: {
    type: String,
    default: ''
  },
})
const { isPlaying, toggle, setVolume, pause } = useAudioPlayer();


watch(() => designerStore.videoBgmData.bgmUrl, (newValue, oldValue) => {
  pause()
}, { deep: true })

watch(() => designerStore.videoBgmData.bgmVolume, (bgmVolume) => {
  setVolume(bgmVolume)
}, { immediate: true, })


const playAudio = () => {
  // 添加播放音频的逻辑
  if (designerStore.videoBgmData.bgmUrl) toggle(designerStore.videoBgmData.bgmUrl);
}
</script>

<style scoped lang="scss">
.bg-music-container {
  max-width: 320px;
  margin: 20px auto;
  border-radius: 12px;
  background: #f9fafb;
  color: #333;
  border: 1px solid #e0e0e0;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;

  :deep() {
    .el-card__body {
      padding: 10px 15px;
    }
  }
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;

  .header-left {
    display: flex;
    align-items: center;

    .cover {
      width: 25px;
      height: 25px;
      display: flex;
      align-items: center;
      transition: transform 0.5s ease;
      margin-right: 15px;
      padding: 5px;
      border: 3px solid #5754f9;
      border-radius: 50%;
      cursor: pointer;
      position: relative;


    }

    .cover-shade {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0.7;
    }

    .rotating {
      animation: rotate 2s linear infinite;
    }
  }

  .header-right {
    display: flex;
    align-items: center;
    font-size: 16px;
    cursor: pointer;

    &:hover {
      color: #5754f9;
      font-weight: bold;
    }
  }
}


.title {
  font-weight: bold;
  color: #5754f9;
}

.subtitle {
  color: #888888;
  font-size: 14px;
}



.control {
  margin: 15px 0;
}

.control label {
  display: block;
  margin-bottom: 5px;
  font-size: 14px;
  color: #666666;
}

.play-button {
  background-color: #5754f9;
  border-color: #5754f9;
  transition: background-color 0.3s, border-color 0.3s;

  &:hover {
    background-color: #4845e6;
    border-color: #4845e6;
  }
}
</style>
